module.exports = __webpack_public_path__ + "assets/img/coin-rwa.2beec2c5.png";